/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowNaturePhotographyTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowNaturePhotography,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Capture Nature’s Beauty!",
    "Photography Adventure Awaits!",
    "Let’s Explore and Snap!",
  ],
  title: "Nature Photography",
  description: "Organize a creative nature photography session.",
  longDescription:
    "Gather your friends for a nature photography session! Choose a date, decide on locations, and plan themes for your photos!",
  emoji: "📷",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Nature Photography",
          emoji: "📷",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the nature photography session?",
          emoji: "📅",
          completeAction: {
            question: "Decide on locations to visit?",
            description: "What locations should we photograph?",
            addModules: [
              {
                type: ModuleType.Location,
                doneType: ModuleDoneType.Voting,
                title: "What locations should we consider?",
                emoji: "🏞",
                completeAction: {
                  question: "Decide on photography themes?",
                  description:
                    "What themes should we follow for our photography?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What themes should we use?",
                      emoji: "🎨",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Capture Nature!",
    outroDescription:
      "Your nature photography plans are set! Enjoy the beauty!",
  },
};
